export {default} from './VerifyAddressPending';
